'use client'

import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useGtm } from '@/hooks'
import { GTM_EVENT } from '@/interfaces/gtm'
import { logger } from '@/lib'
const GTMPageView: React.FC = () => {
  const { sendDataToGTM } = useGtm()
  const pathname = usePathname()

  useEffect(() => {
    try {
      sendDataToGTM({ event: GTM_EVENT.PAGE_VIEW })
    } catch (e) {
      logger.error('Caught GTM error', e as string)
    }
  }, [pathname])

  return null
}

export default GTMPageView
